import React, { useState, useEffect } from "react";
import { loginUser } from "../services/api";
import userimg from "../assets/images/user.png";
import PragyanCircle from "../assets/images/logo-circle.svg";
import DVP from "../assets/images/DIS.png";
import CEDA from "../assets/images/ceda-logo.png";
import NICSI from "../assets/images/nicsi_logo.svg";
import Password from "../assets/images/password.png";
import Email from "../assets/images/email.png";
import showPass from "../assets/images/show-pass.png";
import hidePass from "../assets/images/hide-pass.png";
import Forget from "../assets/images/forget-pass.png";
import { fetchCaptcha } from "../services/api";
import Refresh from "../assets/images/refresh.svg";
import "bootstrap/dist/css/bootstrap.min.css";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [chaptchValue, setChaptchValue] = useState("");
  const [chaptchaTextValue, setChaptchaTextValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [message, setMessage] = useState("");
  const [captchaId, setCaptchaId] = useState();
  const [isDisabled, setDisabled] = useState(false);

  const loadCaptcha = async () => {
    const data = await fetchCaptcha();
    if (data) {
      setChaptchValue(data.captcha_text);
      setCaptchaId(data.captcha_id);
    } else {
      setDisabled(true);
    }
  };

  useEffect(() => {
    loadCaptcha();
  }, []);

  const handleRefresh = async () => {
    setChaptchaTextValue("");
    loadCaptcha();
  };

  const handleCapcha = (e) => {
    setMessage("");
    setChaptchaTextValue(e.target.value);
  };

  const handleChange = (e) => {
    setMessage("");
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleResetFields = () => {
    setChaptchaTextValue("");
    setFormData({
      username: "",
      password: "",
    });
  };

  const handleSubmit = async (e) => {
    setDisabled(true);
    e.preventDefault();
    setIsLoading(true);
    const response = await loginUser(
      formData.username,
      formData.password,
      captchaId,
      chaptchaTextValue
    );

    if (response.status === 200) {
      if (response.data.login_url) {
        window.location.href = response.data.login_url; // Redirect to Superset
        setIsLoading(false);
      }
    } else {
      handleResetFields();
      setMessage(response.response.data.error);
      loadCaptcha();
      setIsLoading(false);
      setDisabled(false);
      if (response.status === 701) {
        alert(response.response.data.error);
      }
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const openPopup = () => {
    alert("Please contact System Admin at pragyan[at]gov[dot]in");
  };

  return (
    <div>
      <div className="signup_bg">
        {isLoading && (
          <div className="loading-overlay">
            <div className="spinner"></div>
          </div>
        )}
        <div className="container-fluid h-100">
          <div className="row outer_bg h-100">
            <div className="order-2 order-md-1 col-sm-12 col-md-6 col-lg-6 text-center">
              <div className="line"></div>
              <div className="dis_form_container">
                <div className="dis_form">
                  <div className="dis_form_heading">
                    <div>
                      <h2>Sign In</h2>
                    </div>
                    <div className="heading_user_img">
                      <img src={userimg} alt="user icon" />
                    </div>
                  </div>
                  <div className="signin_form">
                    {message && (
                      <div className="alert alert-danger">{message}</div>
                    )}
                    <form
                      autoComplete="off"
                      className="form-row mb-3"
                      onSubmit={handleSubmit}
                    >
                      <div className="row signin_block">
                        <div className="col-md-12 mb-2">
                          <div className="DIS_input">
                            <div className="col-auto">
                              <label className="" for="inlineFormInputGroup">
                                EMAIL
                              </label>
                              <div className="input-group mb-2">
                                <div className="input-group-prepend">
                                  <div className="input-group-text">
                                    <img src={Email} alt="Pragyan" />
                                  </div>
                                </div>
                                <input
                                  type="text"
                                  name="username"
                                  className="form-control custom-rounded-input"
                                  onChange={handleChange}
                                  placeholder="Username"
                                  required
                                  autoComplete="off"
                                  rounded
                                  value={formData.username}
                                  maxLength="50"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="DIS_input">
                            <div className="col-auto">
                              <label className="" for="inlineFormInputGroup">
                                PASSWORD
                              </label>
                              <div className="input-group mb-2">
                                <div className="input-group-prepend">
                                  <div className="input-group-text">
                                    <img src={Password} alt="Pragyan" />
                                  </div>
                                </div>
                                <input
                                  type={showPassword ? "text" : "password"}
                                  name="password"
                                  className="form-control custom-rounded-input"
                                  onChange={handleChange}
                                  placeholder="Password"
                                  required
                                  autoComplete="new-password"
                                  rounded-start
                                  value={formData.password}
                                  maxLength="20"
                                />
                                <div className="input-group-append faEye">
                                  <span
                                    onClick={() => togglePasswordVisibility()}
                                    style={{ cursor: "pointer" }}
                                  >
                                    {showPassword ? (
                                      <img
                                        src={showPass}
                                        width={25}
                                        height={25}
                                      />
                                    ) : (
                                      <img
                                        src={hidePass}
                                        width={25}
                                        height={25}
                                      />
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                        <div class="forget_pass">
                          <img src={Forget} alt="Forget password icon" />
                          <a href="" class="go_btn" onClick={openPopup}>
                            {" "}
                            Forgot Password ?{" "}
                          </a>
                        </div>
                      </div>
                      <div className="mb-3">
                        <div className="captcha d-flex align-items-center">
                          <span className="captcha-text p-1 border">
                            {chaptchValue}
                          </span>
                          <input
                            type="text"
                            className="form-control noRound"
                            onChange={handleCapcha}
                            placeholder="Enter Captcha"
                            required
                            value={chaptchaTextValue}
                            maxLength={6}
                          />
                          <button
                            type="button"
                            className="btn refreshBtn"
                            onClick={handleRefresh}
                          >
                            <img src={Refresh} alt="refresh" />
                          </button>
                        </div>
                      </div>
                      <button
                        type="submit"
                        className="btn submit_btn"
                        mat-button
                        disabled={isDisabled}
                      >
                        Sign In
                      </button>
                    </form>
                    {/*
                    <hr />
                    <div className="sign_up mb-2">
                      <p className="mb-2">Don't have an account?</p>
                      <a href="/signup" className="signup_btn">
                        Sign Up
                      </a>
                    </div>
                      */}
                  </div>
                </div>
              </div>
            </div>
            <div className="order-1 order-md-2 col-sm-12 col-md-6 col-lg-6 text-center my-4">
              <div className="dis_title">
                <div className="pragyan_logo_circle">
                  <img src={PragyanCircle} alt="Pragyan" />
                </div>
                <div className="dis_title_image mt-3">
                  <img src={DVP} alt="Data Integration Services" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="footer_inner">
          <div className="footer_line"></div>
          <div className="footer">
            <div className="row adm_row">
              <div className="col-sm-2 col-md-2 px-0">
                <div className="ceda_logo">
                  <img src={CEDA} alt="" />
                </div>
              </div>
              <div className="col-sm-8 col-md-8">
                <div className="footer_title">
                  <p>
                    Data Integration & Exploration Platform, Designed &
                    Developed by
                  </p>
                  <p>
                    <span>
                      CENTRE OF EXCELLENCE FOR DATA ANALYTICS (CEDA), NICSI
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-sm-2 col-md-2 px-0">
                <div className="nicsi_logo">
                  <img src={NICSI} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
